/*
 *
 * Subaccounts reducer
 *
 */

import { fromJS } from 'immutable';
import type { AnyAction } from 'redux';

import {
  DEFAULT_ACTION,
  CREATE_TEAM,
  CREATE_TEAM_SUCCESS,
  CREATE_TEAM_FAILURE,
  CHANGE_TEAMS_VISIBILITY,
  RESET_STATE,
} from './constants';

export const initialState = fromJS({
  teams: [],
  modules: [],
  error: null,
  loading: true,
  teamsVisibility: 'current',
});

function teamsReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case DEFAULT_ACTION:
      return state;
    case CREATE_TEAM:
      return state.set('loading', true).set('error', null);
    case CREATE_TEAM_SUCCESS:
      return state.set('loading', false);
    case CREATE_TEAM_FAILURE:
      return state.set('error', action.error).set('loading', false);
    case CHANGE_TEAMS_VISIBILITY:
      return state.set('teamsVisibility', action.visibility);
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export default teamsReducer;
